import { CompanyFormData } from "Components/Companies/CompanyEdit/CompanyEditForm";
import {
  StyledError,
  StyledRow,
  StyledWrapper,
} from "Components/Companies/CompanyEdit/CompanyEditBasicInfo/CompanyEditBasicInfoStyles";
import { TextInput } from "Components/Shared/Inputs/TextInput";
import * as React from "react";
import { UseFormMethods, FieldError } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";
import { Typography } from "@material-ui/core";
import { DatePicker } from "Components/Shared/Inputs/DatePicker";
import { nameof } from "Utils/ObjectUtils";

type Props = {
  form: UseFormMethods<CompanyFormData>;
};

export const CompanyEditBasicInfo: React.FunctionComponent<Props> = props => {
  const { register, errors, setValue, watch } = props.form;
  const { t } = useResource();
  const { isMarketplaceEnabled, cooperationDueDate } = watch();

  React.useEffect(() => {
    register({ name: nameof<CompanyFormData>("cooperationDueDate") });
  }, [register]);

  const getStringInput = (name: keyof CompanyFormData, label: string) => (
    <div className={name}>
      <TextInput
        label={label}
        name={name}
        inputRef={register}
        fieldError={errors[name] as FieldError}
      />
    </div>
  );

  return (
    <>
      <StyledRow>
        {getStringInput("name", t(Resources.CompanyEdit.Name.Label))}
        {errors.name && (
          <StyledError className={"error-name"}>
            <Typography>{errors.name?.message}</Typography>
          </StyledError>
        )}
      </StyledRow>
      <StyledWrapper>
        {getStringInput(
          "identificationNumber",
          t(Resources.CompanyEdit.IdentificationNumber.Label),
        )}

        {getStringInput(
          "taxIdentificationNumber",
          t(Resources.CompanyEdit.TaxIdentificationNumber.Label),
        )}

        {errors.identificationNumber && (
          <StyledError className={"error-identificationNumber"}>
            <Typography>{errors.identificationNumber?.message}</Typography>
          </StyledError>
        )}
        {errors.taxIdentificationNumber && (
          <StyledError className={"error-taxIdentificationNumber"}>
            <Typography>{errors.taxIdentificationNumber?.message}</Typography>
          </StyledError>
        )}

        {getStringInput("street", t(Resources.CompanyEdit.Street.Label))}

        {getStringInput("streetNo", t(Resources.CompanyEdit.StreetNo.Label))}
        {errors.street && (
          <StyledError className={"error-street"}>
            <Typography>{errors.street?.message}</Typography>
          </StyledError>
        )}
        {errors.streetNo && (
          <StyledError className={"error-streetNo"}>
            <Typography>{errors.streetNo?.message}</Typography>
          </StyledError>
        )}

        {getStringInput("city", t(Resources.CompanyEdit.City.Label))}
        {getStringInput(
          "postalCode",
          t(Resources.CompanyEdit.PostalCode.Label),
        )}
        {errors.city && (
          <StyledError className={"error-city"}>
            <Typography>{errors.city?.message}</Typography>
          </StyledError>
        )}
        {errors.postalCode && (
          <StyledError className={"error-postalCode"}>
            <Typography>{errors.postalCode?.message}</Typography>
          </StyledError>
        )}

        {isMarketplaceEnabled && (
          <>
            <div className={"cooperationDueDate"}>
              <DatePicker
                value={cooperationDueDate}
                label={"Platnost spolupráce do"}
                onChange={val => {
                  setValue(
                    nameof<CompanyFormData>("cooperationDueDate"),
                    val ?? "",
                  );
                }}
              />
            </div>
            {errors.cooperationDueDate && (
              <StyledError className={"error-cooperationDueDate"}>
                <Typography>{errors.cooperationDueDate?.message}</Typography>
              </StyledError>
            )}
          </>
        )}
      </StyledWrapper>
    </>
  );
};
